import { render } from "@/components/collections/templates/AccountTemplate.html?vue&type=template&id=31f5fa30"
import script from "./PortalAccountEditComponent.vue?vue&type=script&lang=js"
export * from "./PortalAccountEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__